import session from '../../utilities/session.js'
import { JSConn } from '@/utilities/js-conn.js'
import { mapGetters } from 'vuex'

export default {
  name: 'SignUpForm',
  data () {
    return {
      emailAddress: null,
      password: null,
      userName: null,
      companyName: null,
      acceptTosPp: null
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()
      const jsConn = new JSConn()
      jsConn.formParams = {
        emailAddress: this.emailAddress,
        password: this.password,
        companyName: this.companyName,
        userName: this.userName,
        acceptTosPp: this.acceptTosPp
      }

      session.createUser(jsConn)
    }
  }
}
